import { useCallback } from 'react';
import { Bot } from 'lucide-react';
import { dataViewApi } from '../../services/dataViewApi';
import { AgentChat } from '../shared/AgentChat';

export default function DataViewChat({
  selectedCompanies,
  onSelectCompany,
  onRemoveCompany,
  onStepResult,
  onWorkspaceAction,
  onThreadCreated,
  onBeforeEdit,
  currentSteps,
  threadId: externalThreadId,
}) {
  // Handle custom SSE events
  const handleCustomEvent = useCallback((eventType, data) => {
    if (eventType === 'step_result') {
      if (onStepResult) onStepResult(data.data || data);
      return true;
    }
    if (eventType === 'workspace_action') {
      const payload = data.data || data;
      console.log('[DataViewChat] workspace_action received:', payload);
      if (onWorkspaceAction) onWorkspaceAction(payload);
      return true;
    }
    return false;
  }, [onStepResult, onWorkspaceAction]);

  // Build context with current_steps
  const buildContext = useCallback((companies, threadId) => ({
    selected_rf_ids: companies.map(c => c.rf_id),
    selected_companies: companies.map(c => ({
      rf_id: c.rf_id, name: c.company_name, source_type: c.source_type,
    })),
    org_id: 'default',
    current_steps: currentSteps || [],
    thread_id: threadId || undefined,
  }), [currentSteps]);

  const emptyState = (handleSend) => (
    <>
      <Bot size={28} className="text-accent/30 mb-3" />
      <p className="text-sm text-zinc-400 mb-4">Describe the data view you want to create. I'll generate the SQL steps for you.</p>
      <div className="space-y-2 w-full max-w-xs">
        {['Show me revenue by company for last quarter', 'Create a view of top 10 customers by spend', 'Monthly expense breakdown by category'].map(prompt => (
          <button
            key={prompt}
            onClick={() => handleSend(prompt)}
            className="w-full text-left px-3 py-2 text-xs text-zinc-500 border border-zinc-200 rounded-lg hover:bg-zinc-50 hover:text-zinc-700 transition-colors"
          >
            {prompt}
          </button>
        ))}
      </div>
    </>
  );

  return (
    <AgentChat
      api={dataViewApi}
      agentName="Data View Agent"
      threadId={externalThreadId}
      onThreadCreated={onThreadCreated}
      selectedCompanies={selectedCompanies}
      onSelectCompany={onSelectCompany}
      onRemoveCompany={onRemoveCompany}
      buildContext={buildContext}
      onCustomEvent={handleCustomEvent}
      header={null}
      emptyState={emptyState}
      placeholder="Describe the data view you want…"
      compact
      enableMessageEdit
      onBeforeEdit={onBeforeEdit}
    />
  );
}
